import React, { useEffect } from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const { params, pageAssetsData, inProgress, error } = props;
  const pageId = params.pageId || props.pageId;

  const dispatch = useDispatch();

  const pageAssetsDataId = pageAssetsData?.[pageId]?.data;

  useEffect(() => {
    if (pageId && !pageAssetsDataId && !inProgress && !error) {
      const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
      const hasFallbackContent = false;
      dispatch(fetchPageAssets(pageAsset, hasFallbackContent));
    }
  }, [dispatch, pageId, pageAssetsDataId, inProgress, error]);

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  return (
    <PageBuilder pageAssetsData={pageAssetsDataId} inProgress={inProgress} schemaType="Article" />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(withRouter, connect(mapStateToProps))(CMSPageComponent);

export default CMSPage;
